import React from "react";
import styled from "styled-components";
import theme from "../../../assets/theme";
import COLORS from "../../../assets/Colors";
import { CustomCheckBox } from "../../common/FormInputs";
import { PrimaryCTAButton, SecondaryCTAButton } from "../../common/Buttons";
import { Modal } from "@material-ui/core";
import { useEffect } from "react";
import { useState } from "react";
import { CustomInputField } from "../../common/FormInputs";
import CustomSelect from "../../common/CustomSelect/CustomSelect";
import {
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@material-ui/core";

const useStyles = makeStyles({
  table: {
    backgroundColor: "transparent",
    borderRadius: 7,
    "& .MuiTableCell-root": {
      borderBottom: 0,
    },
  },
  tableHead: {
    fontFamily: theme.fonts.primaryFontSemiBold,
    color: COLORS.INPUT_LABEL,
    fontSize: 10,
    paddingBottom: 0,
  },
  row: {
    borderBottom: `1px solid ${COLORS.INPUT_BORDER}`,
  },
  radioGroup: {
    "& .MuiRadio-colorPrimary.Mui-checked": {
      color: COLORS.BTN_GREEN,
    },
  },
  formLabel: {
    fontFamily: theme.fonts.primaryFontRegular,
    color: COLORS.COLOR_DARK,
    marginRight: 5,
    // minWidth: 98,
  },
  radioButton: {
    color: COLORS.BTN_GREEN,
  },
});

const EventModal = ({
  modal,
  setModal,
  values,
  handleChange,
  setFieldValue,
  handleBlur,
  touched,
  errors,
  setCredentials,
  credentials,
  data,
}) => {
  const classes = useStyles();
  const [initalData, setInitalData] = useState();
  const [inputFields, setInputFields] = useState([
    {
      fieldType: "text",
      fieldLabel: "Name",
      required: true,
      hidden: false,
      fieldName: "name",
      options: "",
      disabled: true,
    },
    {
      fieldType: "email",
      fieldLabel: "Email",
      required: true,
      hidden: false,
      fieldName: "email",
      options: "",
      disabled: true,
    },
    {
      fieldType: "number",
      fieldLabel: "Mobile Number",
      required: true,
      hidden: false,
      fieldName: "mobileNumber",
      options: "",
      disabled: true,
    },
    {
      fieldType: "text",
      fieldLabel: "Location",
      required: true,
      hidden: false,
      fieldName: "location",
      options: "",
      disabled: true,
    },
    {
      fieldType: "text",
      fieldLabel: "Company Name",
      required: true,
      hidden: false,
      fieldName: "companyName",
      options: "",
      disabled: true,
    },
  ]);

  useEffect(() => {
    if (modal?.state) {
      setInitalData(
        modal?.name === "customisedSignInFieldCheckbox"
          ? values.customisedSignInFieldCheckbox
          : values.customisedRegistrationCheckbox,
      );
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Function to handle changing input field values
  const handleInputChange = (index, event) => {
    const values = [...inputFields];
    values[index][event.target.name] = event.target.value;
    setInputFields(values);
  };

  // Function to handle changing input field values
  const handleCheckboxChange = (index, event, name) => {
    const values = [...inputFields];
    values[index][name] = event.target.checked;
    setInputFields(values);
  };

  // Function to handle removing input fields
  const handleRemoveFields = (index) => {
    const values = [...inputFields];
    values.splice(index, 1);
    setInputFields(values);
  };

  const handleAddFields = () => {
    setInputFields([
      ...inputFields,
      {
        fieldType: "",
        fieldLabel: "",
        required: false,
        hidden: false,
        fieldName: "",
        options: "",
      },
    ]);
  };

  const menuItems = [
    { label: "Email", value: "email" },
    { label: "Text", value: "text" },
    { label: "Radio Button", value: "radioButton" },
    { label: "Dropdown", value: "dropDown" },
    { label: "Checkbox", value: "checkbox" },
    { label: "Number", value: "number" },
    { label: "Country", value: "country" },
    { label: "State", value: "state" },
  ];

  return (
    <Modal
      open={modal?.state}
      onClose={() =>
        setModal({ state: false }) || setFieldValue(modal?.name, initalData)
      }
    >
      <DrawerContainer>
        <Container>
          <HeadingContainer>
            <Heading>{modal?.heading}</Heading>
          </HeadingContainer>
          <FormContainer>
            {/* {modal?.name === "customisedSignInFieldCheckbox" ? (
              values.cutomisedRegistrationCheckbox.filter(
                (checkbox) => checkbox.checked
              ).length ? null : errors["customisedSignInFieldCheckbox"] ? (
                <HelperText>
                  {errors["customisedSignInFieldCheckbox"]}
                </HelperText>
              ) : null
            ) : values.cutomisedRegistrationCheckbox.filter(
                (checkbox) => checkbox.checked
              ).length ? null : errors["cutomisedRegistrationCheckbox"] ? (
              <HelperText>{errors["cutomisedRegistrationCheckbox"]}</HelperText>
            ) : null} */}
            <ContainerGrid>
              {/* {values && modal?.name === "customisedSignInFieldCheckbox"
                ? values?.customisedSignInFieldCheckbox?.map((item, index) => (
                    <CheckboxContainer>
                      <CustomCheckBox
                        type="checkbox"
                        name={`customisedSignInFieldCheckbox[${index}].checked`}
                        checked={item.checked}
                        disabled={item.disable}
                        onBlur={handleBlur}
                        onChange={(event) => {
                          // Handle checkbox change
                          const updatedCheckboxes =
                            values.customisedSignInFieldCheckbox.map((c, i) => {
                              if (c.id === item.id) {
                                return {
                                  ...c,
                                  checked: event.target.checked,
                                };
                              }
                              return c;
                            });
                          setFieldValue(
                            "customisedSignInFieldCheckbox",
                            updatedCheckboxes,
                          );
                        }}
                      />
                      <CheckBoxLabel>{item.label} </CheckBoxLabel>
                    </CheckboxContainer>
                  ))
                : values?.customisedRegistrationCheckbox?.map((item, index) => (
                    <CheckboxContainer>
                      <CustomCheckBox
                        type="checkbox"
                        name={`customisedRegistrationCheckbox[${index}].checked`}
                        checked={item.checked}
                        disabled={item.disable}
                        onBlur={handleBlur}
                        onChange={(event) => {
                          // Handle checkbox change
                          // const updatedCheckboxes =
                          //   values.cutomisedRegistrationCheckbox.map(
                          //     (c, i) => ({
                          //       ...c,
                          //       checked: i === index ? !c.checked : false,
                          //     })
                          //   );
                          const updatedCheckboxes =
                            values.customisedRegistrationCheckbox.map(
                              (c, i) => {
                                if (c.id === item.id) {
                                  return {
                                    ...c,
                                    checked: event.target.checked,
                                  };
                                }
                                return c;
                              },
                            );
                          setFieldValue(
                            "customisedRegistrationCheckbox",
                            updatedCheckboxes,
                          );
                          if (credentials) {
                            const updateData = data.map((c, i) => {
                              return {
                                ...c,
                                disable: false,
                              };
                            });
                            setFieldValue("validationRadioButtons", updateData);
                            setCredentials(false);
                          }
                        }}
                      />
                      <CheckBoxLabel>{item.label} </CheckBoxLabel>
                    </CheckboxContainer>
                  ))} */}

              <TableWrapper>
                <BigTable>
                  <Table className={classes.table}>
                    <TableHead>
                      <TableRow>
                        <TableCell
                          style={{
                            width: 253,
                          }}
                          className={classes.tableHead}
                        >
                          Field Label
                        </TableCell>
                        <TableCell
                          style={{
                            width: 253,
                          }}
                          className={classes.tableHead}
                        >
                          Field Type
                        </TableCell>
                        <TableCell
                          style={{
                            width: 10,
                          }}
                          className={classes.tableHead}
                        >
                          Required
                        </TableCell>
                        <TableCell
                          style={{
                            width: 10,
                          }}
                          className={classes.tableHead}
                        >
                          Hidden
                        </TableCell>
                        <TableCell
                          style={{
                            width: 253,
                          }}
                          className={classes.tableHead}
                        >
                          Key Field{" "}
                        </TableCell>
                        <TableCell className={classes.tableHead}></TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {inputFields?.map((item, index) => (
                        <TableRow className={"table-row"} key={index}>
                          <TableCell
                            component="th"
                            scope="row"
                            style={{ position: "relative" }}
                          >
                            <CustomInputField
                              key={index}
                              className={"input-white"}
                              value={item.fieldLabel}
                              name={`fieldLabel`}
                              onChange={(event) =>
                                handleInputChange(index, event)
                              }
                              disabled={item.disabled}
                              variant="outlined"
                            />
                          </TableCell>
                          <TableCell
                            className="disabledArrows"
                            style={{ position: "relative" }}
                          >
                            <CustomSelect
                              key={index}
                              className={"input-white"}
                              menuItemValues={menuItems}
                              value={item.fieldType}
                              name={`fieldType`}
                              onChange={(event) =>
                                handleInputChange(index, event)
                              }
                              disabled={item.disabled}
                              variant="outlined"
                            />
                          </TableCell>
                          <TableCell
                            className="disabledArrows"
                            style={{ position: "relative" }}
                          >
                            <CheckboxContainer>
                              <CustomCheckBox
                                checked={item.required}
                                name={`required`}
                                onChange={(event) =>
                                  handleCheckboxChange(index, event, "required")
                                }
                                disabled={item.disabled}
                                variant="outlined"
                              />
                              <CheckBoxLabel>Required</CheckBoxLabel>
                            </CheckboxContainer>
                          </TableCell>
                          <TableCell
                            className="disabledArrows"
                            style={{ position: "relative" }}
                          >
                            <CheckboxContainer>
                              <CustomCheckBox
                                checked={item.hidden}
                                name={`hidden`}
                                onChange={(event) =>
                                  handleCheckboxChange(index, event, "hidden")
                                }
                                variant="outlined"
                              />
                              <CheckBoxLabel>Hidden</CheckBoxLabel>
                            </CheckboxContainer>
                          </TableCell>
                          <TableCell
                            className="disabledArrows"
                            style={{ position: "relative" }}
                          >
                            <CustomInputField
                              key={index}
                              className={"input-white"}
                              value={item.fieldName}
                              name={`fieldName`}
                              onChange={(event) =>
                                handleInputChange(index, event)
                              }
                              disabled={item.disabled}
                              variant="outlined"
                            />
                          </TableCell>
                          <TableCell align="center" style={{ width: 100 }}>
                            {inputFields.length > 1 && (
                              <DeleteIcon
                                onClick={() => handleRemoveFields(index)}
                                src={require("../../../assets/images/removeIcon.svg")}
                              />
                            )}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </BigTable>
                <ButtonWrapper>
                  <SecondaryCTAButton onClick={() => handleAddFields()}>
                    + Add new
                  </SecondaryCTAButton>
                </ButtonWrapper>
              </TableWrapper>
            </ContainerGrid>
          </FormContainer>
          <FormControls>
            <Row>
              <PrimaryCTAButton
                style={{ marginRight: "12px" }}
                onClick={() =>
                  !errors["customisedSignInFieldCheckbox"] &&
                  !errors["customisedRegistrationCheckbox"] &&
                  setModal({ state: false })
                }
              >
                Save
              </PrimaryCTAButton>
              <PrimaryCTAButton
                onClick={() =>
                  setModal({ state: false }) ||
                  setFieldValue(modal?.name, initalData)
                }
              >
                Cancel
              </PrimaryCTAButton>
            </Row>
          </FormControls>
        </Container>
      </DrawerContainer>
    </Modal>
  );
};

export default EventModal;

const Container = styled.div`
  margin: 0 15px;
  background-color: white;
  outline: none;
  border-radius: 20px;
  @media ${theme?.breakpoints?.sm_up} {
    margin: 0;
  }
`;

const DrawerContainer = styled.div`
  width: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  @media ${theme?.breakpoints?.sm_up} {
    max-width: 80%;
  }
`;

const FormContainer = styled.p`
  color: ${COLORS.COLOR_DARK};
  font-size: 14px;
  font-family: ${theme.fonts.primaryFontRegular};
  padding: 24px 15px 30px 15px;
  max-height: 435px;
  overflow: auto;
  @media ${theme?.breakpoints?.sm_up} {
    padding-top: 24px;
    padding-left: 60px;
    padding-right: 40px;
    padding-bottom: 30px;
  }
`;

const HeadingContainer = styled.div`
  padding-top: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  margin-bottom: 20px;
`;

const Heading = styled.h3`
  margin: 0;
  padding: 0;
  font-size: 18px;
  font-weight: 800;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: ${COLORS.LIGHT_BLUE_LABEL};
  font-family: ${theme.fonts.primaryFontExtraBold};
`;

export const ContainerGrid = styled.div`
  border-radius: 10px;
  @media ${theme?.breakpoints?.sm_up} {
    width: 100%;
    grid-gap: 10px;
    padding: 0;
    border-radius: 0;
    background-color: transparent;
  }
`;

export const FormControls = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
`;

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 15px;
  margin-bottom: 15px;
`;

export const CheckBoxLabel = styled.span`
  font-family: ${theme.fonts.primaryFontSemiBold};
  font-size: 14px;
  color: ${COLORS.COLOR_DARK};
  cursor: pointer;
`;

export const CheckboxContainer = styled.div`
  width: 10%;
  display: flex;
  align-items: center;
  @media ${theme.breakpoints.sm_up} {
    width: 10%;
  }
`;

const ButtonWrapper = styled.div`
  width: fit-content;
  @media ${theme?.breakpoints?.md_up} {
    justify-content: flex-start;
    display: flex;
    padding-bottom: 20px;
    padding-top: 10px;
  }
`;

const DeleteIcon = styled.img`
  width: 20px;
  height: 20px;
  object-fit: contain;
  cursor: pointer;
  margin-top: 10px;
`;

const TableWrapper = styled.div`
  @media ${theme?.breakpoints?.md_up} {
    background-color: #f9f9f9;
    border-radius: 7px;
  }
`;

const BigTable = styled.div`
  display: none;
  @media ${theme?.breakpoints?.md_up} {
    display: block;
  }
`;
